export const ApiToken = {
  token: process.env.VUE_APP_TOKEN || 'token',
  url: process.env.VUE_APP_URL || 'https://www.avevacommunity.com/test/',
  shareUrl: process.env.VUE_APP_SHARE_URL || 'https://www.avevacommunity.com/test/#/',
  baseApi: process.env.VUE_APP_BASE_API || 'https://www.avevacommunity.com/testapi/api',
  channel: process.env.VUE_APP_CHANNEL || 'channel',
  roadShowId: process.env.VUE_APP_ROADSHOW_ID || '10867',
  trainingWx: process.env.VUE_APP_TRAINING_WX || '10876', 
  trainingLs: process.env.VUE_APP_TRAINING_LS || '10878',
  trainingForm: Number(process.env.VUE_APP_TRAINING_FORM) || 10882,
  roadShowForm: Number(process.env.VUE_APP_ROADSHOW_FORM) || 10883,
  workShopId: process.env.VUE_APP_WORKSHOP_ID || '10885',
  paper2023: Number(process.env.VUE_APP_PAPER_2023) || 10912,
  paper2025: Number(process.env.VUE_APP_PAPER_2025) || 10913,
  e3dPositionId: 10820,
}